import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/sidenav/sidenav.service';
import { OverviewComponent } from './overview/overview.component';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../core/services/local-storage.service';
import { PageTitleService } from '../services/pagetitle.service';
import { UxComponent } from './ux/ux.component';
import { WebsiteAuditService } from './website-audit.service';
import { NotificationService } from '../core/services/notification.service';
import { ManagementComponent } from './management/management.component';
import { CrComponent } from './cr/cr.component';
import { DiagnosticComponent } from './diagnostic/diagnostic.component';
import { TechnicalComponent } from './technical/technical.component';
import { SeoComponent } from './seo/seo.component';
import { GeoComponent } from './geo/geo.component';
import { SeoService } from '../seo/seo.service';
import { SelectionService } from '../services/selection.service';

@Component({
  selector: 'app-website-audit',
  templateUrl: './website-audit.component.html',
})
export class WebsiteAuditComponent implements OnInit {
  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private sidenavService: SidenavService,
    private localStorageService: LocalStorageService,
    private pageTitle: PageTitleService,
    private websiteAuditService: WebsiteAuditService,
    private notificationService: NotificationService,
    private seoService: SeoService,
    private selectorService: SelectionService,
  ) {}

  private subs = new Subscription();

  public selectedTab = 0;
  public tabs = [
    {
      label: 'Overview',
      role: 'websiteAudit',
      component: OverviewComponent,
      disabled: false,
    },
    {
      label: 'UX',
      role: 'websiteAudit',
      component: UxComponent,
      disabled: false,
    },
    {
      label: 'CR',
      role: 'websiteAudit',
      component: CrComponent,
      disabled: false,
    },
    {
      label: 'SEO',
      role: 'websiteAudit',
      component: SeoComponent,
      disabled: true,
    },
    {
      label: 'GEO',
      role: 'websiteAudit',
      component: GeoComponent,
      disabled: true,
    },
    {
      label: 'Technical',
      role: 'websiteAudit',
      component: TechnicalComponent,
      disabled: false,
    },
    {
      label: 'Diagnostic',
      role: 'websiteAudit',
      component: DiagnosticComponent,
      disabled: false,
    },
    {
      label: 'Audits',
      role: 'websiteAudit',
      component: ManagementComponent,
      disabled: false,
      dontShowOnShare: true,
    },
  ];

  taskId: string = '';
  selectedAuditTask: any = null;
  isShareableComponent: boolean = false;
  token: string = '';

  private selectedTaskResponse: any;

  private timeout: any;
  private timeoutSeconds: number = 20;

  private timeoutTasks: any;

  ngOnInit(): void {
    this.pageTitle.setTitle('Website Audit');

    if (this.router.url.includes('/share/website-audit')) {
      this.isShareableComponent = true;
    }

    const capitalizeFirstLetter = (str: any) => {
      try {
        return str.charAt(0).toUpperCase() + str.slice(1);
      } catch (e) {
        return str;
      }
    };

    this.subs.add(
      this.sidenavService.getActiveTabIndex().subscribe((index: any) => {
        const isDisabled = this.tabs[index].disabled;
        if (isDisabled) {
          this.selectedTab = this.tabs.findIndex((tab) => !tab.disabled);
        } else {
          this.selectedTab = index;
        }
      }),
    );

    const UXTab: any = this.tabs.find((t: any) => t.label == 'UX');
    const CRTab: any = this.tabs.find((t: any) => t.label == 'CR');
    const TechTab: any = this.tabs.find((t: any) => t.label == 'Technical');
    const DiagTab: any = this.tabs.find((t: any) => t.label == 'Diagnostic');
    const SEOCard: any = this.tabs.find((t: any) => t.label == 'SEO');
    const GEOCard: any = this.tabs.find((t: any) => t.label == 'GEO');

    if (this.isShareableComponent) {
      this.tabs = this.tabs.filter((tab) => !tab.dontShowOnShare);

      this.token = this.route.snapshot.paramMap.get('token') as string;

      const SEOCard: any =
        this.tabs.find((card: any) => card.label == 'SEO') || {};
      const GEOCard: any =
        this.tabs.find((card: any) => card.label == 'GEO') || {};

      this.subs.add(
        this.websiteAuditService.getAuditTaskFromToken(this.token).subscribe({
          next: (res: any) => {
            if (res) {
              res['domain'] = this.getDomainFromUrl(res?.url);
              res['formatted_domain'] = capitalizeFirstLetter(
                this.getDomainFromUrl(res?.url)?.split('.')[0],
              );

              UXTab['disabled'] =
                res?.uxProgress < 100 || res?.crStatus == 'failed';
              CRTab['disabled'] =
                res?.uxProgress < 100 || res?.crStatus == 'failed';
              TechTab['disabled'] =
                res?.insightProgress < 100 || res?.technicalStatus == 'failed';
              DiagTab['disabled'] =
                res?.errorProgress < 100 || res?.errorStatus == 'failed';

              this.subs.add(
                this.websiteAuditService
                  .getAuditGeneral({
                    domain: res['domain'],
                  })
                  .subscribe({
                    next: (data: any) => {
                      res['website_name'] = data?.general_obj?.website_name;
                      this.websiteAuditService.updateSelectedAuditTask(res);

                      SEOCard['disabled'] = false;
                      GEOCard['disabled'] = false;
                    },
                    error: (err: any) => {
                      this.websiteAuditService.updateSelectedAuditTask(res);
                      SEOCard['disabled'] = true;
                      GEOCard['disabled'] = true;
                    },
                  }),
              );
            }
          },
          error: (err: any) => {
            this.notificationService.error(err?.error?.message);
          },
        }),
      );
      return;
    }

    const params = new URLSearchParams(window.location.search);

    params.forEach((value, key) => {
      if (key === 'taskId') {
        this.taskId = value;
      }
    });

    // target change
    this.subs.add(
      this.selectorService.currentMessage.subscribe((message) => {
        this.selectedTaskResponse = null;
        this.selectedAuditTask = null;
        this.websiteAuditService.fetchAuditTasks();
      }),
    );

    // tasks list
    this.subs.add(
      this.websiteAuditService.getAuditTasks().subscribe((tasks) => {
        const isEveryTaskFailed = tasks?.every(
          (t: any) => t.status === 'Failed',
        );

        if (tasks?.length > 0 && !isEveryTaskFailed) {
          const areThereTasksInProgress = tasks.some(
            (task: any) => task.progress < 100,
          );

          if (this.timeoutTasks) {
            clearTimeout(this.timeoutTasks);
            this.timeoutTasks = null;
          }
          if (areThereTasksInProgress) {
            this.timeoutTasks = setTimeout(() => {
              this.websiteAuditService.fetchAuditTasks();
            }, this.timeoutSeconds * 1000);
          }

          if (
            !this.selectedTaskResponse ||
            this.selectedTaskResponse?.progress < 100 ||
            this.selectedTaskResponse?.taskId != this.selectedAuditTask?.taskId
          ) {
            if (this.taskId) {
              this.selectedAuditTask =
                tasks?.find((task: any) => task?.taskId === this.taskId) ||
                null;
            } else {
              let task = this.findTaskFromStatus(tasks, 'done');
              const firstTask = tasks?.[0] || null;

              // if done doesn't exists get one that is running
              if (!task) {
                task = this.findTaskFromStatus(tasks, 'running');
              }

              // get the first one if its not failed
              if (!task && firstTask?.status != 'Failed') {
                task = firstTask;
              }

              this.selectedAuditTask = task;
            }

            if (!this.selectedAuditTask) {
              this.selectedAuditTask =
                tasks?.find(
                  (task: any) => task?.status?.toLowerCase() === 'done',
                ) ||
                tasks?.[0] ||
                null;
            }

            this.router.navigate([], {
              queryParams: {
                taskId:
                  this.selectedTaskResponse?.taskId ||
                  this.selectedAuditTask?.taskId,
              },
              queryParamsHandling: 'merge',
              replaceUrl: true,
            });

            this.getAuditTask();
          }
        } else {
          this.selectedAuditTask = null;
          this.tabs.forEach((tab: any) => {
            if (tab.label != 'Overview' && tab.label != 'Audits') {
              tab.disabled = true;
            }
          });
          this.websiteAuditService.updateSelectedAuditTask(null);
        }
      }),
    );

    // selected task
    this.subs.add(
      this.websiteAuditService.getSelectedAuditTask().subscribe((res: any) => {
        if (res) {
          if (this.selectedTaskResponse?.taskId != res?.taskId) {
            setTimeout(() => {
              this.getAuditTask();
            }, 50);
          }
          this.selectedTaskResponse = res;
          this.taskId = res?.taskId || this.taskId;

          UXTab['disabled'] =
            res?.uxProgress < 100 || res?.crStatus == 'failed';
          CRTab['disabled'] =
            res?.uxProgress < 100 || res?.crStatus == 'failed';
          TechTab['disabled'] =
            res?.insightProgress < 100 || res?.technicalStatus == 'failed';
          DiagTab['disabled'] =
            res?.errorProgress < 100 || res?.errorStatus == 'failed';

          const crawlStatus = res?.organicProgress?.status;
          const averageStatusBar = res?.organicProgress?.progress;

          if (averageStatusBar >= 100 && crawlStatus != 'failed') {
            SEOCard['disabled'] = false;
            GEOCard['disabled'] = false;
          } else {
            SEOCard['disabled'] = true;
            GEOCard['disabled'] = true;
          }

          if (this.tabs[this.selectedTab].disabled) {
            this.selectedTab = 0;
            this.sidenavService.updateActiveTabIndex(this.selectedTab);
          }
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    if (this.timeoutTasks) {
      clearTimeout(this.timeoutTasks);
      this.timeoutTasks = null;
    }
  }

  private findTaskFromStatus(tasks: any, status: string) {
    return (
      tasks.find((task: any) => task?.status?.toLowerCase() === status) || null
    );
  }

  getAuditTask() {
    if (!this.selectedAuditTask) {
      return;
    }

    const taskId =
      this.selectedTaskResponse?.taskId || this.selectedAuditTask?.taskId;

    this.subs.add(
      this.websiteAuditService.getAuditTask(taskId).subscribe({
        next: (res) => {
          this.websiteAuditService.updateSelectedAuditTask({
            ...this.selectedTaskResponse,
            ...res,
          });

          if (
            !this.selectedTaskResponse?.organicProgress ||
            this.selectedTaskResponse?.organicProgress?.progress < 100
          ) {
            this.getStatusOfProject(res);
          }
        },
        error: (err) => {
          this.websiteAuditService.updateSelectedAuditTask(null);
          this.notificationService.error(err?.error?.message);
        },
      }),
    );
  }

  getDomainFromUrl(url: string): string | null {
    try {
      const normalized = url.startsWith('http') ? url : `https://${url}`;

      const { hostname } = new URL(normalized);
      return hostname.replace(/^www\./, '');
    } catch {
      return null;
    }
  }

  getStatusOfProject(res: any) {
    if (!res) return;

    const domainFromUrl = this.getDomainFromUrl(res?.url);

    this.seoService.getStatusOfProject({ domain: domainFromUrl }).subscribe({
      next: (res: any) => {
        const crawlStatus = res?.progresses?.[0]?.crawl_status || '';

        this.websiteAuditService.updateSelectedAuditTask({
          ...this.selectedTaskResponse,
          organicProgress: {
            progress: res?.averageStatusBar,
            status: crawlStatus,
          },
        });
      },
      error: (err) => {
        this.websiteAuditService.updateSelectedAuditTask({
          ...this.selectedTaskResponse,
          organicProgress: {
            progress: 0,
            status: 'failed',
          },
        });
      },
    });
  }

  private _animationRunning = false;
  get animationRunning() {
    return this._animationRunning;
  }
  indexChange() {
    this._animationRunning = true;
  }
  onAnimationDone() {
    this.sidenavService.updateActiveTabIndex(this.selectedTab);
    this._animationRunning = false;
    this.sidenavService.triggerPageChange();
  }

  checkRoleGuard(page: any) {
    const role: string[] = this.localStorageService.get('privileges') || [];
    if (role.length > 0) {
      if (role.findIndex((priv) => priv == page) < 0) {
        return false;
      } else {
        return true;
      }
    } else {
      this.router.navigate(['login']);
      return false;
    }
  }
}
